// @ts-nocheck
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StickyHeader } from 'subscription/components/stickyheader/StickyHeader';
import { Product } from 'bootstrap/data/product/Product';
import { SocialProof } from '../socialproof/SocialProof';
import { isApplePayAvailable } from 'subscription/components/Payments/Payments.utlls';
import { ApplePayElement } from 'subscription/recurly/components/elements/applepay/ApplePayElement';
import { DefaultElements } from 'subscription/recurly/components/elements/default/DefaultElements';
import { SlideUpPanel } from 'subscription/recurly/components/slideuppaymentform/SlideUpPaymentForm';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { RECURLY_KEY } from 'utils/utils.constants';
import { useFeatures } from 'useFeatures';
import Alert from 'components/error/Error';
import ApplyPay from 'assets/icon_btn_apple_pay.svg';
import { PaymentMethods } from 'subscription/components/Payments/Payments.types';
import { usePaymentsLogic } from 'subscription/recurly/components/paymentpicker/PaymentsPicker.hook';
import { useRecurlyLogic } from 'subscription/recurly/Recurly.hook';
import MoneyBackCheck from 'assets/money_back_check_ic.svg';
import styles from './styles.module.scss';

type Props = {
  product: Product;
  currencyCode?: string;
  planType?: PlanSelectType;
  handleGetPlanClick: () => void;
  children: JSX.Element[] | JSX.Element;
};

export const PlanSectionWrapper = ({
  product,
  children,
  currencyCode,
  planType,
  handleGetPlanClick,
}: Props) => {
  const startDate = Date.now();
  const [showOtherPayments, setShowOtherPayments] = useState(false);

  return (
    <RecurlyProvider publicKey={RECURLY_KEY as any}>
      <Elements>
        <PlanSectionPayments
          curencyCode={currencyCode}
          product={product}
          children={children}
          handleGetPlanClick={handleGetPlanClick}
          startDate={startDate}
          planType={planType}
          showOtherPayments={showOtherPayments}
          setShowOtherPayments={setShowOtherPayments}
        />
      </Elements>
    </RecurlyProvider>
  );
};

type PaymentsProps = {
  product: Product;
  children: JSX.Element[] | JSX.Element;
  handleGetPlanClick: () => void;
  startDate: number;
  showOtherPayments: boolean;
  currencyCode?: string;
  planType?: PlanSelectType;
  setShowOtherPayments: React.Dispatch<React.SetStateAction<boolean>>;
};

const PlanSectionPayments = ({
  product,
  children,
  handleGetPlanClick,
  startDate,
  showOtherPayments,
  currencyCode,
  planType,
  setShowOtherPayments,
}: PaymentsProps) => {
  const { t } = useTranslation();
  const { onPaymentSuccess, onPaymentError } = useRecurlyLogic();

  const { isSingleSubscriptionFlow } = useFeatures();

  const {
    handlePaymentMethodChange,
    errorMessage,
    isPaypalLoading,
    setErrorMessage,
  } = usePaymentsLogic({
    product,
    onSuccess: onPaymentSuccess,
    onError: onPaymentError,
  });

  const showApplePay = isSingleSubscriptionFlow && isApplePayAvailable();

  return (
    <>
      <Alert
        visible={!!errorMessage}
        error={errorMessage}
        onClose={() => setErrorMessage('')}
      />
      <div className={styles.wrapper}>
        <h3 className={styles.title}>{t('planSectionTitle')}</h3>

        <StickyHeader startDate={startDate} trialLength={product.trialLength} />

        {children}

        {!isSingleSubscriptionFlow && <SocialProof />}

        {showApplePay ? (
          <div className={styles.applePayContainer}>
            <div className={styles.moneyBackGuarantee}>
              <img src={MoneyBackCheck} alt="" /> 100% money-back guarantee
            </div>
            <ApplePayElement
              showChecklist={false}
              label={
                <div className={styles.applyPayBtn}>
                  Continue with <img src={ApplyPay} />{' '}
                  <span style={{ marginLeft: '-40px', fontSize: '18px' }}>
                    Pay
                  </span>
                </div>
              }
              isLoading={isPaypalLoading}
              onPay={() => handlePaymentMethodChange(PaymentMethods.ApplePay)}
            />
            <button
              className={styles.linkButton}
              onClick={() => setShowOtherPayments(true)}
            >
              {t('See other payment methods')}
            </button>
          </div>
        ) : (
          <button className={styles.submit} onClick={handleGetPlanClick}>
            {t('Continue')}
          </button>
        )}

        <SlideUpPanel
          product={product}
          currencyCode={currencyCode}
          isOpen={showOtherPayments}
          planType={planType}
          onClose={() => setShowOtherPayments(false)}
        >
          <DefaultElements
            product={product}
            onPaymentSuccess={onPaymentSuccess}
            onPaymentError={onPaymentError}
            shouldShowPaymentLabel={false}
          />
        </SlideUpPanel>
      </div>
    </>
  );
};
